<template>
<div>
    <b-modal id="matterDamagesClaimFormModal" ref="matterDamagesClaimFormModal" centered size="lg" no-close-on-backdrop :title=" $t('matterDamagesClaim.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-row>
            <b-col class="col-lg-12">
                <b-form>
                    <label>{{ $t('matterDamagesClaim.damages_claim_type') }}</label>
                    <b-form-group>
                        <b-form-select size="sm" v-model="lawDamagesClaimTypeSelect" value-field="id" text-field="name" :options="lawDamagesClaimTypeOption" />
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterDamagesClaim.claimed_amount') }}</label>
                    <b-form-group>
                        <cleave v-model="claimedAmount" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterDamagesClaim.awarded_amount') }}</label>
                    <b-form-group>
                        <cleave v-model="awardedAmount" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterDamagesClaim.collected_amount') }}</label>
                    <b-form-group>
                        <cleave v-model="collectedAmount" class="cleaveStyle form-control" :options="cleaveOptions"></cleave>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterDamagesClaim.client_refund_method') }}</label>
                    <b-form-group>
                        <b-form-select size="sm" v-model="lawSecurityDepositClientRefundMethodSelect" value-field="id" text-field="name" :options="lawSecurityDepositClientRefundMethodOption" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterDamagesClaim.client_refund_date') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="securityDepositClientRefundDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label>{{ $t('matterDamagesClaim.client_report_date') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" placeholder="" size="sm" v-model="securityDepositClientReportDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawDamagesClaimTypeSelect: 0,
            lawDamagesClaimTypeOption: [],
            lawSecurityDepositClientRefundMethodSelect: 0,
            lawSecurityDepositClientRefundMethodOption: [],
            claimedAmount: 0,
            awardedAmount: 0,
            collectedAmount: 0,
            securityDepositClientRefundDate: null,
            securityDepositClientReportDate: null,
            cleaveOptions: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2,
                delimiter: '.',
                numeralDecimalMark: ',',
            },
        }
    },
    methods: {
        showDamagesClaim(id, lawMatterId) {
            this.$refs['matterDamagesClaimFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterDamagesClaim'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.lawDamagesClaimTypeOption = response.data.lawDamagesClaimTypeList
                    this.lawDamagesClaimTypeOption.splice(0, 0, this.$nullSelected())
                    this.lawDamagesClaimTypeSelect = response.data.lawMatterDamagesClaim.lawDamagesClaimTypeId

                    this.lawSecurityDepositClientRefundMethodOption = response.data.lawSecurityDepositClientRefundMethodList
                    this.lawSecurityDepositClientRefundMethodOption.splice(0, 0, this.$nullSelected())
                    this.lawSecurityDepositClientRefundMethodSelect = response.data.lawMatterDamagesClaim.lawSecurityDepositClientRefundMethodId

                    this.claimedAmount = response.data.lawMatterDamagesClaim.claimedAmount
                    this.awardedAmount = response.data.lawMatterDamagesClaim.awardedAmount
                    this.collectedAmount = response.data.lawMatterDamagesClaim.collectedAmount
                    this.securityDepositClientRefundDate = response.data.lawMatterDamagesClaim.securityDepositClientRefundDate
                    this.securityDepositClientReportDate = response.data.lawMatterDamagesClaim.securityDepositClientReportDate
                } else {
                    this.$bvModal.hide('matterDamagesClaimFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                lawMatterId: this.lawMatterId,
                lawDamagesClaimTypeId: this.lawDamagesClaimTypeSelect,
                lawSecurityDepositClientRefundMethodId: this.lawSecurityDepositClientRefundMethodSelect,
                claimedAmount: this.claimedAmount,
                awardedAmount: this.awardedAmount,
                collectedAmount: this.collectedAmount,
                securityDepositClientRefundDate: this.securityDepositClientRefundDate,
                securityDepositClientReportDate: this.securityDepositClientReportDate,
            }
            const controller = {
                name: 'LawMatterDamagesClaim'
            }
            const payload = {
                data: data,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if (!this.id) {
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(27, this.id, this.lawMatterId, this.employeeId)
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterDamagesClaimFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
